import {postRequest, URL_SERVER} from './../requests'


export async function login(){
    const data = {
        "username": "alexe.petcov@prisma-holding.eu",
        "password":"Mobitoken123!"
        }
    try {

        const responsePromise = await postRequest(URL_SERVER + '/user/login', data)
        const token = responsePromise["data"]["token"]
        const refreshToken = responsePromise["data"]["refresh_token"]
        const createdTimestamp = responsePromise["data"]["created_at"]
        return {
            token: token,
            refreshToken: refreshToken,
            createdTimestamp: createdTimestamp
        }
    } catch (error) {
        console.error(error);
    }

}